import { createController, createControllerEndpoint } from '../utils/api'
import { useGlobalProject } from 'src/utils/globals';
import { CombinedDesigns, ApiSettings, UserModel } from 'src/types';

const project = useGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/projects/' + project.UniqueCode, {
    getCombinedDesigns: createControllerEndpoint<CombinedDesigns>('GET', '/design'),
    saveChecklistsDesign: createControllerEndpoint<void>('PUT', '/checklists-design'),
    updateSettingsApi: createControllerEndpoint<void>('PUT', '/settings/api'),
    getSettingsApi: createControllerEndpoint<ApiSettings>('GET', '/settings/api'),
    updateAppUrl: createControllerEndpoint<void>('PUT', '/general/app-url'),
    getUsers: createControllerEndpoint<UserModel[]>('GET', '/users')
});

export const projects2 = createController('/api/v1/projects', {
    updateAppUrl: createControllerEndpoint<void>('PUT', '/{projectCode}/general/app-url'),
});